import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import { ReactComponent as RightchevronIcon } from 'common/assets/images/rightchevron.svg';

import styles from './Breadcrumbs.module.scss';

type BreadcrumbsProps = {
	breadcrumbs: any;
	className?: any;
	customClass?: boolean;
};

const { iconGrey, iconWhite } = styles;

const Breadcrumbs = ({
	breadcrumbs,
	className,
	customClass,
}: BreadcrumbsProps) => (
	<MuiBreadcrumbs
		separator={<RightchevronIcon fill={!customClass ? iconGrey : iconWhite} />}
		aria-label="breadcrumb"
		className={customClass ? className : styles['bread-crumbs']}
		sx={{
			'& .MuiBreadcrumbs-li': {
				background: 'none',
			},
			'& .MuiBreadcrumbs-separator': {
				marginLeft: 1,
				'&:hover': {
					background: 'none',
				},
			},
		}}
	>
		{breadcrumbs}
	</MuiBreadcrumbs>
);

export default Breadcrumbs;
